<div class="wrapper-feedback-form">
    <div class="section-title row">
        <div class="section-btn">
            <button routerLink='/dashboard/e-ticketing-list' class="btn btn-back" [attr.aria-label]="'Back' | translate">
              <i class="fi-rr-arrow-alt-left"></i>
            </button>
        </div>
        <div>
            <div class="title" [attr.data-parent]="'Feedback' | translate">{{'Create Feedback' |translate}}</div>
        </div>
    </div>

    <div class="section-main">
      <form [formGroup]="messagesForm" (ngSubmit)="messagesTopic()"  method="post">
            <div class="row" >
              <div class="message-info col-6" >
                <div class="card h-2 mt-4">
                    <!--<h4 class="title">Company address</h4>
                    <p class="subtitle">
                        The physical address of your store or place of business. If you don't have a
                        business address, enter the address from which you ship orders.
                    </p>-->
                    <div class="row mt-2">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                            <h4 class="title-2 mt-2">{{'Topic' |translate}}</h4>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                            <select formControlName="topic_id" class="form-select" aria-label="Default select example"
                            [ngClass]="{'form-select-error' :messagesForm.get('topic_id').errors && messagesForm.get('topic_id').touched}">
                              <option selected>{{'Select Topic' |translate}}</option>
                              <option *ngFor="let data of feedback" value="{{data.feedback_topic_id}}">{{ '{0}' | translate:[ utils.translate(data.topic)] }}</option>
                            </select>
                            <span *ngIf="messagesForm.get('topic_id').errors && messagesForm.get('topic_id').touched">
                              <span style="color: #EB5757;" *ngIf="messagesForm.get('topic_id').touched">{{'Topic field is required.' |translate}}</span>
                          </span>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                            <h4 class="title-2 mt-2">{{'Message' |translate}}</h4>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                            <div class="form-group">
                              <textarea formControlName="message" name="name" rows="4"  class="form-area"
                              [ngClass]="{'form-area-error' : messagesForm.get('message').errors?.minlength && messagesForm.get('message').dirty || messagesForm.get('message').errors && messagesForm.get('message').touched}">
                            </textarea>
                            <span *ngIf="messagesForm.get('message').errors && !messagesForm.get('message').errors?.minlength">
                              <span style="color: #EB5757;" *ngIf="messagesForm.get('message').touched">{{'Message field is required.' |translate}}</span>
                          </span>
                            <span *ngIf="messagesForm.get('message').errors?.minlength">
                              <span style="color: #EB5757;" *ngIf="messagesForm.get('message').errors?.minlength">Message field must be at least 6 characters in length.</span>
                          </span>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                            <h4 class="title-2 mt-2">{{'Image' |translate}}</h4>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                            <div class="form-group">
                              <div class="col">
                                  <div class="section-upload" (click)="open()">
                                      <div *ngIf="!imgURL" class="btn btn-primary">{{'Upload Image' |translate}}</div>
                                      <input #file class="d-none" type="file" accept="image/*" (change)="preview(file.files)">
                                      <img  *ngIf="imgURL" [src]="imgURL" class="image-uploaded ">
                                  </div>
                                <div *ngIf="imgURL" class="btn btn-primary float-center" (click)="removeImage()">{{'Remove Image' |translate}}</div>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div align="right" class=" mt-3">
                      <button  class="btn btn-blue-small" [disabled]="messagesForm.get('message').errors || !messagesForm.get('message').errors?.minlength && !messagesForm.get('message').dirty
                      || messagesForm.get('topic_id').errors && messagesForm.get('topic_id').touched || messagesForm.get('topic_id').errors">{{'Submit Feedback' |translate}}</button>
                    </div>
                    <div class="loader" *ngIf="showloader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                </div>
              </div>
            </div>
        </form>
    </div>
</div>
